module.exports = __webpack_public_path__ + "static/media/logo.3c88b6c1.svg";